// Adds `Math.sign` support for IE 11.

if (!Math.sign) {
	Math.sign = function(x: number) {
	  return (x > 0) ? 1 : ((x < 0) ? -1 : +x);
	}
}
